// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"627e223c","239":"5a2dc616","453":"ad1eb3c3","667":"d65d683d"}[chunkId] + ".chunk.js";
};